<template>
	<div
		v-if="languageLoaded && userLoaded"
		class="page"
	>

		<router-view v-if="$route.path === '/team/switch'" />

		<template v-else>

			<Navigation />

			<div class="main">

				<TrialWarning
					v-if="objectLength(userTeam) && (!user.verified || userTeam.plan.title === 'TRIAL')"
				/>

				<div
					v-loading="loading"
					class="main-wrap"
					:class="{ 'with-trial': objectLength(userTeam) && userTeam.plan.title === 'TRIAL' }"
				>
					<div class="main-content">
						<router-view />
						<FooterComponent v-if="ready" />
					</div>
				</div>

			</div>

			<SwitchTeam />

			<ExpirationDialog />

			<PlanLimitDialog />

		</template>

	</div>
</template>

<script>
import '@/style/app.scss'

import axios from 'axios'
import { mapState } from 'vuex'

import { _getAccount } from '@/services/api/account'
import { _getTeams } from '@/services/api/teams'

import loadTranslations from '@/services/mixins/loadTranslations'
import updateLeaveConfirmation from '@/services/mixins/updateLeaveConfirmation'

export default {
	name: 'PrivateLayout',
	mixins: [
		loadTranslations,
		updateLeaveConfirmation
	],
	components: {
		Navigation: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Layout/Navigation'),
		FooterComponent: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Layout/Footer'),
		SwitchTeam: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Dialog/SwitchTeam'),
		TrialWarning: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Misc/TrialWarning'),
		ExpirationDialog: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Dialog/ExpirationDialog'),
		PlanLimitDialog: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Dialog/PlanLimitDialog')
	},
	data () {
		return {
			userLoaded: false,
			interval: null,
			languageLoaded: false
		}
	},
	computed: {
        ...mapState([
			'activeNavigation',
			'loading'
		])
	},
	created () {
		this.ajaxLoadData()
	},
	methods: {
		ajaxLoadData () {
			axios.all([
				_getAccount(),
				_getTeams()
			])
			.then(axios.spread((res1, res2) => {
				const user = res1
				const teams = res2

				this.$store.dispatch('setUser', user).then(() => {
					this.loadTranslations(user.settings.language)
					this.$store.dispatch('setTeams', teams)
					this.userLoaded = true
				})

				if (teams.length === 0) {
					this.redirectTo('/team/fallback')
				} else {

					if (this.user.settings.lastTeam) {
						const index = teams.findIndex(item =>
							item.id === user.settings.lastTeam
						)
						if (index >= 0) {
							this.$store.dispatch('setTeam', teams[index])
							this.redirectTo(`/${process.env.VUE_APP_DEFAULT_PAGE}`)
						}
					} else {
						this.$store.dispatch('setTeam', teams[0])
						this.redirectTo(`/${process.env.VUE_APP_DEFAULT_PAGE}`)
					}

				}

			}))
			.catch(error => {
				const errorCode = error.response.data.status
				setTimeout (() => {
					this.displayMessage(this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
				}, 200)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.page {
	display: flex;
	height: 100vh;
	overflow: hidden;
	width: 100%;
}
</style>
